import { Shop } from "../api/FoxOrderApi";
import BaseStore from "../base/BaseStore";
import { ActionInterface, StoreActionType } from "../constant/ActionConstant";
import AppDispatcher from "../dispatcher/AppDispatcher";
import Service from "../model/service/Service";


class FoxOrderStore extends BaseStore {
    private _service: Service
    private _shops: Shop[]

    constructor() {
        super();
        this._service = new Service()
        this._shops = []
    }

    public get shops(): Shop[] {
        return this._shops;
    }

    public get service(): Service {
        return this._service;
    }

    setService(service: Service) {
        this._service = service
        this.emitChange()
    }

    setShopOrFranchise(shops: Shop[]) {
        this._shops = shops
        this.emitChange()
    }
}

const storeAction = (store: FoxOrderStore) => {
    return (action: ActionInterface) => {
        switch (action.type) {
            case StoreActionType.SET_FOXORDER_V2_SERVICE:
                store.setService(action.data);
                break;
            case StoreActionType.SET_FOXORDER_V2_SHOPS:
                store.setShopOrFranchise(action.data);
                break;
        }
    }
}

const FoxOrderStoreShared = new FoxOrderStore()
FoxOrderStoreShared.dispatchToken = AppDispatcher.register(storeAction(FoxOrderStoreShared) as (payload: unknown) => void);


export default FoxOrderStoreShared
export const store = FoxOrderStore
export const action = storeAction